class ProductStickyAddToCart {
  constructor(bar) {
    this.bar = bar;
    this.section = bar.closest('.shopify-section') || document;
    this.button = bar.querySelector('[data-sticky-product-button]');
    this.label = bar.querySelector('[data-sticky-product-label]');
    this.footer = document.querySelector('.footer, footer');
    this.primaryButton = this.findPrimaryButton();
    if (!this.primaryButton || !this.button) return;

    this.titleSource = this.section.querySelector('.belt-product__title, .product__title h1, h1');
    this.priceSource = this.section.querySelector('[data-gloves-price], .belt-product__price, .price__container');
    this.imageSource = this.section.querySelector('.belt-product__media-panel:not([hidden]) img, .product__media img');
    this.bindEvents();
    this.observeProductState();
    this.sync();
    this.updateVisibility();
  }

  findPrimaryButton() {
    return this.section.querySelector('[data-add-bundle], [data-gloves-submit], .belt-product__add:not([data-sticky-product-button]), product-form [name="add"]');
  }

  bindEvents() {
    this.button.addEventListener('click', () => {
      if (this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true') return;
      this.primaryButton.click();
      this.sync();
    });
    window.addEventListener('scroll', () => this.updateVisibility(), { passive: true });
    window.addEventListener('resize', () => this.updateVisibility(), { passive: true });
  }

  observeProductState() {
    const observer = new MutationObserver(() => this.sync());
    observer.observe(this.section, { attributes: true, childList: true, subtree: true, characterData: true });
    this.section.querySelectorAll('input[name="id"], input[name="quantity"]').forEach((input) => {
      input.addEventListener('change', () => window.setTimeout(() => this.sync(), 0));
    });
  }

  sync() {
    if (!this.primaryButton) return;
    const unavailable = this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';
    const loading = this.primaryButton.classList.contains('loading') || this.primaryButton.classList.contains('is-loading');
    if (this.button.disabled !== (unavailable || loading)) this.button.disabled = unavailable || loading;
    this.button.classList.toggle('is-loading', loading);
    if (this.label) {
      const primaryText = this.primaryButton.textContent.replace(/\s+/g, ' ').trim();
      const nextLabel = unavailable && !loading ? (primaryText || 'Sold out') : 'Add to cart';
      if (this.label.textContent !== nextLabel) this.label.textContent = nextLabel;
    }

    const title = this.titleSource?.textContent?.trim();
    const titleTarget = this.bar.querySelector('[data-sticky-product-title]');
    if (title && titleTarget && titleTarget.textContent !== title) titleTarget.textContent = title;

    const price = this.readPrice();
    const priceTarget = this.bar.querySelector('[data-sticky-product-price]');
    if (price && priceTarget && priceTarget.textContent !== price) priceTarget.textContent = price;

    const activeImage = this.section.querySelector('.belt-product__media-panel:not([hidden]) img, .product__media-item.is-active img, .product__media img');
    const imageTarget = this.bar.querySelector('[data-sticky-product-image]');
    if (activeImage?.currentSrc && imageTarget && imageTarget.src !== activeImage.currentSrc) imageTarget.src = activeImage.currentSrc;
  }

  readPrice() {
    const priceNode = this.section.querySelector('[data-gloves-price] > span, .belt-product__price > span, .price-item--sale, .price-item--regular');
    return priceNode?.textContent?.trim() || '';
  }

  updateVisibility() {
    if (!this.primaryButton) return;
    const buttonRect = this.primaryButton.getBoundingClientRect();
    const footerRect = this.footer?.getBoundingClientRect();
    const footerVisible = footerRect ? footerRect.top < window.innerHeight && footerRect.bottom > 0 : false;
    const drawerOpen = document.querySelector('cart-drawer.active');
    const visible = buttonRect.bottom < 0 && !footerVisible && !drawerOpen;
    this.bar.classList.toggle('is-visible', visible);
    this.bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }
}

const initProductStickyAtc = (scope = document) => {
  scope.querySelectorAll('[data-product-sticky-atc]').forEach((bar) => {
    if (!bar.productStickyAtc) bar.productStickyAtc = new ProductStickyAddToCart(bar);
  });
};

document.addEventListener('DOMContentLoaded', () => initProductStickyAtc());
document.addEventListener('shopify:section:load', (event) => initProductStickyAtc(event.target));
